import type { CollectionNames } from "@/api/clients/directus-client"
import type { DirectusBookableChargingUnit } from "@/types/directus-types"
import { directusReadByQuery, directusUpdateOne } from "./helperFunctions"

const collectionName: CollectionNames = 'BookableChargerUnit'

  const query = {
    fields: [
      'id',
      'evse_id',
      'display_name',
      'description',
    ],
  }

/**
 * Fetches all bookable charging units from directus.
 *
 * @returns {Promise<DirectusBookableChargingUnit[]>} A list of `DirectusBookableChargingUnit` objects if successful, undefined if it errors out.
 */
export async function fetchBookableChargingUnits() {
  return await directusReadByQuery<DirectusBookableChargingUnit>(collectionName, query)
}

/**
 * Fetches a single bookable charging unit from directus.
 *
 * @param id the id of the bookable charging unit
 * @returns {Promise<DirectusBookableChargingUnit>} A `DirectusBookableChargingUnit` object if successful, undefined if it errors out.
 */
export async function fetchBookableChargingUnit(id: string | number) {
  return await directusReadByQuery<DirectusBookableChargingUnit>(collectionName, { id, ...query })
}

/**
 * Edits a single bookable charging unit in directus.
 *
 * @param id The id of the bookable charging unit to be edited.
 * @param dataToUpdate A partial `DirectusBookableChargingUnit` object containing the fields to be updated.
 * @returns {Promise<DirectusBookableChargingUnit>} A `DirectusBookableChargingUnit` object if successful, undefined if it errors out.
 */
export async function editBookableChargingUnit(id: string | number, dataToUpdate: Partial<DirectusBookableChargingUnit>) {
  return await directusUpdateOne<DirectusBookableChargingUnit>(collectionName, id, dataToUpdate, query)
}
